module.exports = require("@swa-ui/application/src/DarkModeToggle/DarkModeToggle.module.scss");